import { render, staticRenderFns } from "./DeliverySettingsView.vue?vue&type=template&id=744a3b62&"
import script from "./DeliverySettingsView.vue?vue&type=script&lang=ts&"
export * from "./DeliverySettingsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports